import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-button',
  imports: [CommonModule],
  templateUrl: './button.html',
  styleUrl: './button.scss',
  standalone: true,
})
export class Button {
  @Input() text!: string;
  @Output() buttonClick = new EventEmitter<void>();
  @Input() disabled = false;

  handleClick() {
    this.buttonClick.emit();
  }
}
